import {AsyncActDecorator} from '@gongxigames/framework/slotV2/fsm/acts/decorators/AsyncActDecorator';

export class RefreshBalanceAct extends AsyncActDecorator {
    public async execute(): Promise<void> {
        this.emitter.emit('Game.command.refreshBalance');
    }

    public getName(): string {
        return 'RefreshBalanceAct';
    }
}